<div [ngClass]="{'no-scroll': lockScroll}">
    <div *ngIf="!loading">
        <div class="quote-title">Here are the following FSP providers that will cover your
            <span>{{quote.bikeManufacturer}} {{quote.bikeModel}}</span></div>

        <div style="padding-bottom:80px">
            <div *ngFor="let quoteItem of quote.quoteItem">
                <div class="quote-item" (click)="selectInsurer(quoteItem.providerID)"
                     [ngClass]="{'selected': selectedInsurer===quoteItem.providerID}"
                     [ngStyle]="{'border-color': selectedInsurer===quoteItem.providerID ? quoteItem.primaryColorCode : '#F2F4F6'}">
                    <div class="header">
                        <img src="{{quoteItem.providerLogo}}"/>
                        <div class="price"><span>R</span>{{quoteItem.premiumAmount}}</div>
                    </div>
                    <div class="blurb">
                        <div [innerHTML]="quoteItem.overview | safeHtml"
                             [ngStyle]="{'color': quoteItem.primaryColorCode}"></div>
                    </div>
                    <div class="estimated-time">
                        {{quoteItem.estimatedTime}}
                    </div>
                    <div class="disclaimer">
                        <div [innerHTML]="quoteItem.disclaimer | safeHtml"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pop-over" [ngClass]="{'hidden': !showPopOver}">
        <div class="header">
            <div class="provider-logo">
                <img src="{{getProviderLogo()}}"/>
            </div>
            <div class="done" (click)="closePopOver()">CLOSE</div>
        </div>
        <!--<div class="about">
          ABOUT OUR COVER
        </div>-->
        <div class="pop-over-content">
            <div [innerHtml]="getInformation() | safeHtml"></div>
            <div class="disclaimer-large">
                <div [innerHTML]="getDisclaimer() | safeHtml"></div>
            </div>
        </div>
        <div class="bottom-button">
            <button pButton class="p-modern full-width" label="GET QUOTE" [disabled]="!selectedInsurer || loading"
                    (click)="getQuote()"></button>
        </div>
    </div>

</div>

<!--
  id: 2
  providerID: 1
  provider: "Pineapple"
  benefits: "<ul class="provider-benefits"><li><div class="title">Easy and Affordable</div><div class="description">No paying for cover you dont need. Insure only the things you want from R1.00 p/m</div></li></ul>"
  providerLogo: "https://user-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_300,w_300,f_auto,q_auto/1333174/Pineapple_icon_zvm2r5.png"
  primaryColorCode: "#68c9d0"
  secondaryColorCode: "#ffd400"
  redirectURL: ""
  premiumAmount: 325
-->
